export default "__VITE_ASSET__e308ae90__"